// This file is auto-generated by scripts/generate-translations-index-index.ts
// Do not edit this file directly

// Import all translation files
import de from './de.json';
import en from './en.json';
import it from './it.json';
import fr from './fr.json';
import ko from './ko.json';
import es from './es.json';
import ar from './ar.json';

// Define the translation structure type
export interface TranslationMap {
  [key: string]: string;
}

// Export a single object containing all translations
const translations: Record<string, TranslationMap> = {
  de,
  en,
  it,
  fr,
  ko,
  es,
  ar,
};

export default translations;
